module.exports = __webpack_public_path__ + "static/media/felt.5ca5a855.png";